export default __webpack_public_path__ + "static/media/login-page-image.593a29cc.svg";